import React from 'react';
import FrontTarifs from './tarifs'
import FormPage from './formPage';
import FieldYesNo from './fields/fieldYesNo';
import FieldText from './fields/fieldText';
import FieldDate from './fields/fieldDate';
import FrontOptions from './options'
import FrontFooter from './footer'
import FieldCheck from './fields/fieldCheck'
import FrontEcheancier from './echeancier';


const IBAN_Updater = (iban) => {
    iban = iban.toUpperCase().replace(/[^A-Z0-9]/g, '')
    let rt = iban.substring(0,4)
    if ( iban.length>4 ) rt += ' '+iban.substring(4,8)
    if ( iban.length>8 ) rt += ' '+iban.substring(8,12)
    if ( iban.length>12 ) rt += ' '+iban.substring(12,16)
    if ( iban.length>16 ) rt += ' '+iban.substring(16,20)
    if ( iban.length>20 ) rt += ' '+iban.substring(20,24)
    if ( iban.length>24 ) rt += ' '+iban.substring(24,27)
    return rt
}

export default class FrontConfirmTarif extends FormPage {
    
    constructor(props) {
        super(props);
        this.title = 'Souscription'
        this.fields = {
            'periodicite':true,
            'formule':true,
            'hamon_deja_assure':{
                'hamon_assure_au_moins_12_mois':{
                    'hamon_resiliation_necessaire':{
                        'hamon_resiliation_envoyee':true
                    }
                }
            },
            'date_effet':true,
            'numero_permis':true,
            'immatriculation':true,
            'numero_serie':true,
            'assure_30_derniers_jours':true
        }
        this.nextTitle = 'Payer'
    }

    componentDidMount() {
        // If the user comes from comparateurs, we mark the flag comparateursCompleted to indicate
        // user has now validated page details1. Now user can come back from vous, vehicule, antecedents
        // straight here without having to revalidate details1.
        if ( this.props.devis.params.MER ) this.props.changeParams({'comparateursCompleted':1})
    }

    componentDidUpdate() {
        if ( ! this.props.devis.validated ) {
            this.props.validateDevis()
        }
    }

    next() {
        this.props.onSubscribe()
    }

    back() {
        this.props.setPage('antecedents')
    }

    renderInvalid(container) {
        const devis = this.props.devis
        const params = devis.params
        return <>
            <div className="contentvbox">
                <h1>Votre devis est en attente de validation</h1>
                <p className="main_line">
                Compte tenu des informations que vous avez saisies, votre dossier nécessite un traitement manuel
                de la part de nos équipes.
                </p>
                <FrontTarifs container={container}/>

                <p className="main_line">
                Si certaines informations sont erronées, n'hésitez pas à les modifier en cliquant sur le bouton ci-dessous&nbsp;:
                </p>
                <p>
                    <a className="button button_subscribe" onClick={()=>this.props.setPage(params.MER?'details1':'vehicule')}>
                        Modifier ma demande de devis <span>▸</span>
                    </a>
                </p>
                <FrontFooter extraText="Pour finaliser votre devis, appelez nous au&nbsp;:"/>
            </div>
        </>

    }

    doRender(container) {

        const toPay = this.props.devis.toPay()
        this.nextTitle = toPay ? ( <>Payer {toPay} €</> ) : 'Payer'

        const toPayYearly = this.props.devis.toPayYearly()
        const devis = this.props.devis
        const params = devis.params

        if ( devis.validated == -2 ) return this.renderInvalid(container)
        return <>
             <div className="contentvbox">
                <FieldYesNo field="hamon_deja_assure" container={container} />
                {( params.hamon_deja_assure == 'O' )?
                    <FieldYesNo field="hamon_assure_au_moins_12_mois" container={container} />:''}
                {(( params.hamon_deja_assure == 'O' )&&( params.hamon_assure_au_moins_12_mois == 'O' ))?
                    <FieldYesNo field="hamon_resiliation_necessaire" container={container} />:''}
                {(( params.hamon_deja_assure == 'O' )&&( params.hamon_assure_au_moins_12_mois == 'O' )&&( params.hamon_resiliation_necessaire == 'O' ))?
                    <FieldYesNo field="hamon_resiliation_envoyee" container={container} />:''}
                {devis.hamonApplies()
                ? <p><span className="notice">La loi Hamon nous oblige à faire la demande de résiliation auprès de votre ancien assureur.
                    <br/><u>Votre contrat avec nous ne prendra effet qu'une fois la résiliation effective.</u>
                </span></p>
                : <FieldDate field="date_effet" container={container} />}
                
                <FieldText field="numero_permis" container={container} />
                <FieldText field="immatriculation" container={container} />
                {(params.numero_serie_inconnu=='O')
                ?<></>
                :<FieldText field="numero_serie" container={container} notice="Les 7 derniers caractères de la section E de votre carte grise. Si vous ne connaissez pas votre numéro de série, indiquez 0000000"/>}
                
                <FieldYesNo field="assure_30_derniers_jours" container={container} />
            </div>
            <div className="contentvbox">

                <h2>Choisissez votre formule et votre fréquence de paiement</h2>
                <FrontTarifs container={container}/>
                <h2>Ajoutez vos options</h2>
                <FrontOptions container={container}/>

                <FrontEcheancier container={container} />

                {(params.periodicite=='M')?<>
                    <FieldText field="iban" container={container}/>
                    <i>27 caractères commençant par FR</i>
                    <FieldCheck field="own_iban" container={container}/>
                </>:<></>}
                
                { toPay ? <><p>Acompte à payer par CB à la souscription : <span className="price">{this.props.devis.toPay()} €</span>
                    { ( params.periodicite == 'M' )?<><span className="notice">L'acompte inclut les frais de gestion et de courtage ainsi que les deux premiers mois.<br/>Puis, par mois, à partir du 3<sup>ème</sup> mois : </span><span className="price">{this.props.devis.toPayMonthly()} €</span></>:''}
                    { ( params.periodicite == 'A' )?<><span className="notice">L'acompte inclut les frais de gestion et de courtage et une année de cotisation</span></>:''}

                </p><p className="text">
                Votre cotisation annuelle TTC est de <b>{toPayYearly} €</b>, dont <b>{this.props.devis.fees()} €</b> de frais de gestion et de courtage, renouvelables chaque année. 
                </p>
                <p className="text">
                <u>Les
                frais de courtage et de gestion ne sont pas remboursables en cas de résiliation.</u>
                </p></> : '' }
                <FieldCheck field="accept_cgu" container={container}/>
            </div>
        </>
    }
}
